import { Button, ConfigProvider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import useNavigateBack from '@/shared/hooks/useNavigateBack';

/**
 * Botón para retroceder en la navegación. Si no existe una entrada previa válida en el historial,
 * redirige a la ruta de respaldo definida.
 * 
 * Si no se define una ruta de respaldo, se utiliza `ROUTES.HOME`.
 */
export const BackButton = ({ fallbackTo, fallbackOptions, style, children = 'Volver', ...buttonProps }) => {
  const navigateBack = useNavigateBack();

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            colorLink: '#595959',
            algorithm: true,
          },
        },
      }}
    >
      <Button
        type='link'
        icon={<FontAwesomeIcon icon={faArrowLeft} />}
        onClick={() => navigateBack(fallbackTo, fallbackOptions)}
        style={{ width: 'fit-content', padding: 0, ...style }}
        {...buttonProps}
      >
        {children}
      </Button>
    </ConfigProvider>
  );
};

// Marca el componente como un botón de Ant Design para que sea tratado como tal por los componentes que lo requieren
BackButton.__ANT_BUTTON = true;